<template>
    <div class="tourismDetail">
        <home-nav></home-nav>
        <div class="tourismDetailBox tra-flex-col tra-flex-align-center">
            <div class="tourismDetailTit tra-flex-row tra-flex-align-center">
                <div class="tourismMk">
                    旅游包车
                </div>

                <span>
                    >
                </span>

                <div class="tourismOut">
                    境外旅游
                </div>

                <span>
                    >
                </span>

                <div class="tourismTit">
                    {{ title }}
                </div>
            </div>

            <div class="tourismParticulars">
                <div class="tourismParticularsTit">
                    {{ title }}
                </div>
                <div class="tourismParticularsRed tra-flex-row tra-flex-justify-between tra-flex-align-center">
                    <p class="colorText">
                        {{ redTit }}
                    </p>
                    <div class="tourismParticularsRedRight tra-flex-row tra-flex-align-center">
                        <div class="bmNumber bianju">
                            {{ peopleNumber }}人已报名
                        </div>
                        <div class="codeType bianju">
                            <img src="@/assets/images/tourism/saoyisao.png" alt="">
                            <span>手机购买</span>
                        </div>
                        <div class="codeType bianju" @click="collectBtn()">
                            <img :src="isCollect ? collectIs : collectNo" alt="">
                            <span>收藏</span>
                        </div>
                        <div class="codeType bianju">
                            <img src="@/assets/images/tourism/share.png" alt="">
                            <span>分享</span>
                        </div>
                    </div>
                </div>

                <div class="tourismDetailBot tra-flex-row">
                    <div class="tourismDetailBotLeft">
                        <div class="charter-detail-img">
                            <swiper :options="swiperOptionTop" class="gallery-top imgs" ref="swiperTop">
                                <swiper-slide class="slide-1 imgsList" v-for="(item,index) in imgData" :key="index">
                                    <img :src="item" alt="">
                                </swiper-slide>
                                <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
                                <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
                            </swiper>
                            <!-- swiper2 Thumbs -->
                            <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
                                <swiper-slide class="slide-1" v-for="(item,idx) in imgData" :key="idx">
                                    <img :src="item" alt="">
                                </swiper-slide>
                            </swiper>
                        </div>

                        <div class="tourismCalendar">
                            <calender></calender>
                        </div>
                    </div>
                    <div class="tourismDetailBotRight">
                        <div class="topPrice tra-flex-row tra-flex-align-center">
                            <div class="title">
                                <span>行程价格:</span>
                            </div>

                            <div class="money">
                                <span>¥</span>
                                <p>{{ adult_price }}</p>
                                <span>元起(成人)</span>
                            </div>

                            <div class="money">
                                <span>¥</span>
                                <p>{{ child_price }}</p>
                                <span>元起(儿童)</span>
                            </div>

                            <div class="priceExplain">
                                <span>价格说明？</span>
                            </div>
                        </div>

                        <div class="topPriceDetail">
                            <div class="topPriceDetailSingle">
                                <div class="titleSingle">
                                    产品特色:
                                </div>
                                <div class="labelList">
                                    <div class="labelText" v-for="(item,index) in signal" :key="index">
                                        <span>{{ item }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="topPriceDetailSingle">
                                <div class="titleSingle">
                                    出发城市:
                                </div>
                                <div class="labelList">
                                    <div class="labelDiv">
                                        {{ city_name }}
                                    </div>
                                </div>
                            </div>

                            <div class="topPriceDetailSingle">
                                <div class="titleSingle">
                                    旅游天数:
                                </div>
                                <div class="labelList">
                                    <div class="labelDiv">
                                        {{ travel_days }}天
                                    </div>
                                </div>
                            </div>

                            <div class="topPriceDetailSingle">
                                <div class="titleSingle">
                                    承办单位:
                                </div>
                                <div class="labelList">
                                    <div class="labelDiv">
                                        {{ undertaker }}
                                    </div>
                                </div>
                            </div>

                            <div class="topPriceDetailSingle">
                                <div class="titleSingle">
                                    退改政策:
                                </div>
                                <div class="labelList">
                                    <div class="labelDiv">
                                        支持退改，特殊原因保障
                                    </div>
                                </div>

                                <div class="viewpolicy">
                                    查看政策
                                </div>
                            </div>
                        </div>

                        <div class="reservation">
                            <div class="reservationTit">
                                行程预定：
                            </div>

                            <div class="reservationTitSingle">
                                <div class="titleSingle" style="height: 40px;line-height: 40px;">
                                    行程套餐:
                                </div>
                                <div class="labelList">
                                    <div class="reservationText">
                                        <span>{{ travel_package }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="reservationTitSingle">
                                <div class="titleSingle" style="height: 40px;line-height: 40px;">
                                    行程日期:
                                </div>
                                <div class="labelList">
                                    <el-date-picker
                                            v-model="timeData"
                                            type="daterange"
                                            range-separator="至"
                                            :start-placeholder="beginDate"
                                            :end-placeholder="endDate"
                                            value-format="yyyy-MM-dd"
                                            :picker-options="pickerOptions0"
                                            @change="change">
                                    </el-date-picker>
                                </div>
                            </div>

                            <div class="reservationTitSingle">
                                <div class="titleSingle" style="height: 40px;line-height: 40px;">
                                    出游人数:
                                </div>

                                <div class="travelNumber">
                                    <div class="travelNumberBox">
                                        <div class="travelNumberBoxLeft">
                                            <span>￥{{ crAllMoney }}</span>
                                            <p>/成人</p>
                                        </div>
                                        <div class="travelNumberBoxRight">
                                            <span @click="crreduce()">-</span>
                                            <p>{{ crNumber }}</p>
                                            <span @click="cradd()">+</span>
                                        </div>
                                    </div>
                                    <div class="travelNumberBox">
                                        <div class="travelNumberBoxLeft">
                                            <span>￥{{ etAllMoney }}</span>
                                            <p>/儿童</p>
                                            <div>（身高1.2米以下）</div>
                                        </div>
                                        <div class="travelNumberBoxRight">
                                            <span @click="etreduce()">-</span>
                                            <p>{{ etNumber }}</p>
                                            <span @click="etadd()">+</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="btnBox">
                                <div class="btnBoxLeft">
                                    <span>
                                        合计：
                                    </span>
                                    <p>
                                        ￥{{ moneyAll }}
                                    </p>
                                </div>
                                <div class="btnBoxRight" @click="signUp()">
                                    马上报名
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="tr-content">
                <div class="tr-detail">
                    <!--行程安排-->
                    <div class="tr-scheduling scheduling-box">
                        <div class="titleList">
                            <div class="titleListSingle" :class="currentNumber == index ? 'titleListSingleAc' : ''"
                                 v-for="(item,index) in tabList" :key="index" @click="tabClick(index)">
                                {{ item.text }}
                            </div>
                        </div>

                        <!--xc-->
                        <div class="tr-day-detail tr-day-detail-one" v-for="(item,index) in 2" :key="index">
                            <div class="tr-day-top">
                                <div class="tr-day-top-icon">
                                    <span>{{ index + 1 }}</span>
                                </div>
                                <p class="tr-day-title">
                                    厦门出发—专车接机/站—游览景点—入驻酒店
                                </p>
                            </div>
                            <div class="tr-day-process">
                                <div class="tr-day-cost">
                                    <span>·入住:</span>
                                    <p>
                                        泉州泰禾洲际高级房大双 788元/晚
                                    </p>
                                </div>
                                <div class="tr-day-cost">
                                    <span>·车程:</span>
                                    <p>约3小时</p>
                                </div>
                                <div class="tr-day-cost">
                                    <span>·餐饮:</span>
                                    <p>
                                        成人不含餐、儿童不含餐
                                    </p>
                                </div>
                            </div>
                            <div class="tr-day-information">
                                <p>
                                    <strong>西街</strong>：西街早在宋朝时候就繁荣至极，街道两侧是保存良好的古建筑，里内汇聚了泉州众多知名小吃，可谓半街烟火半缘佛（开元寺在西街内）。<br>
                                </p>
                                <p>
                                    <strong>开元寺</strong>：开元寺始建于唐朝的皇家寺庙，迄今1300多年，是福建省内规模最大的佛教寺庙。<br>
                                    <strong>关岳庙</strong>：关岳庙始建于宋代，庙内香火终年旺盛，信徒远及东南亚及台湾，求签问卦者日不知凡几。<br>
                                </p>
                                <p>
                                    <strong>闽台缘博物馆</strong>：国家级对台专题博物馆，彰显闽台同宗同源，非常适合小朋友参观学习。<br>
                                    <strong>洛阳桥</strong>：洛阳桥，素有“海内第一桥”美誉，同赵州桥齐名。傍晚夕阳将将垂落，湖面如金，桥面如银，金银交相辉映，美不胜收。<br>
                                </p>
                                <p>
                                    <strong>晋江五店市</strong>：鸟瞰五店市，红砖飞檐富有建筑美感，洋楼点缀彷如红花中生白玉，凭添三分异域风情。<br>
                                </p>
                                <div class="tr-day-imgs">
                                    <img src="@/assets/images/tourism/share.png" alt="">
                                    <img src="@/assets/images/tourism/share.png" alt="">
                                    <img src="@/assets/images/tourism/share.png" alt="">
                                    <img src="@/assets/images/tourism/share.png" alt="">
                                    <img src="@/assets/images/tourism/share.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--费用说明-->
                    <div class="tr-scheduling fysm">
                        <div class="scheduling-title">
                            <div class="scheduling-text">
                                <!--<img src="{{ asset('pc/image/index/pc_nav_icon_cost.png') }}" alt="">-->
                                <span>费用说明</span>
                            </div>
                        </div>

                        <div class="tr-expenses">
                            <div class="expenses-include">
                                <div class="expenses-include-title">
                                    费用包含
                                </div>
                                <ul class="expenses-ul">
                                    <li class="expenses-li" v-for="(item,index) in price_contain" :key="index">
                                        <div>{{ item.key }}</div>
                                        <p>{{ item.val }}</p>
                                    </li>
                                    <!--<li class="expenses-li">
                                        <div>住宿</div>
                                        <p>行程所列酒店住宿费用。</p>
                                    </li>
                                    <li class="expenses-li">
                                        <div>用餐</div>
                                        <p>成人包含1次早餐</p>
                                    </li>
                                    <li class="expenses-li">
                                        <div>门票</div>
                                        <p>行程中所列景点，清源山成人票65（1.2米以下儿童免票，1.2-1.4半票）；<br>南少林成人票70（1.2米以下儿童免票，1.2-1.4半票）。</p>
                                    </li>-->
                                </ul>
                            </div>
                            <div class="expenses-include">
                                <div class="expenses-include-title">
                                    费用不包含
                                </div>
                                <ul class="expenses-ul">
                                    <li class="expenses-li" v-for="(item,index) in price_no_contain" :key="index">
                                        <div>{{ item.key }}</div>
                                        <p>{{ item.val }}</p>
                                    </li>
                                    <!--<li class="expenses-li">
                                        <div>保险</div>
                                        <p>不包含</p>
                                    </li>-->
                                    <!--<li class="expenses-li">
                                        <div>其他</div>
                                        <p>
                                            ①超重行李的托运费、保管费； <br>
                                            ②酒店内洗衣、理发、电话、传真、收费电视、饮品、烟酒等个人消费； <br>
                                            ③自由活动期间的用车服务； <br>
                                            ④提供导游服务的产品在自由活动期间无陪同服务； <br>
                                            ⑤当地参加的自费以及“费用包含”中不包含的其他项目 <br>
                                        </p>
                                    </li>-->
                                </ul>
                            </div>

                            <div class="tr-principle">
                                <div class="tr-principle-title">
                                    · 退款及取消预定原则
                                </div>
                                <div class="tr-principle-content">
                                    <p>
                                        <!--①退款原则（因个人原因推出活动的）；<br>
                                        ②行程前4-6日取消合同，扣除违约金20%；<br>
                                        ③行程前1-3日取消合同，扣除违约金40%；<br>
                                        ④行程开始当日取消合同，扣除违约金60%；<br>
                                        ⑤行程预定在国家法定节假日（以国务院发布为准），包括元旦、春节、清明节、劳动节、端午节、中秋节、国庆节，预定成功后提出取消的，依据退款责任方，扣除违约金50%； <br>
                                        ⑥因部分旅游资源需提前预订的特殊性，本产品线路在旅行社成团后至出行前6天外取消的，也将产生实际损失。具体损失包括但不限于机票、酒店等。 如游客需要取消订单，应及时联系旅行社，旅行社除协助游客减损，并退还未实际产生的损失费用外，不再承担其他赔偿责任。 <br>-->

                                        {{ refund_info }}
                                    </p>
                                </div>
                            </div>


                            <div class="tr-principle">
                                <div class="tr-principle-title">
                                    · 商家违约规则
                                </div>
                                <div class="tr-principle-content">
                                    <p>
                                        预订成功后，因商家原因取消订单的，除全额退款外，还应向游客支付违约金（不可抗力除外），标准如下：
                                    </p>
                                    <p>
                                        ①行程前1天18:00之前（含）取消，除全额退款外，还应向游客支付合同金额的0%作为用户损失费；<br>
                                        ②行程前1天22:00之前（含）取消，除全额退款外，还应向用户支付合同金额的30%作为用户损失费；<br>
                                        ③行程前1天22:00之后取消，除全额退款外，还应向用户支付订单合同的50%作为用户损失费<br>
                                    </p>
                                </div>
                            </div>

                            <div class="tr-principle">
                                <div class="tr-principle-title">
                                    · 时差说明
                                </div>
                                <div class="tr-principle-content">
                                    <p>
                                        上述时间均为商品当地时间。
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!--注意事项-->
                    <div class="tr-scheduling zysx">
                        <div class="scheduling-title">
                            <div class="scheduling-text">
                                <!--<img src="{{ asset('pc/image/index/pc_nav_icon_notice.png') }}" alt="">-->
                                <span>注意事项</span>
                            </div>
                        </div>

                        <div class="tr-attention">
                            <div class="attention-ul">
                                <div class="attention-li">
                                    <div class="attention-li-title">
                                        · 人身,财产安全
                                    </div>
                                    <p class="attention-li-content">
                                        ①为了您的人身、财产安全，请您避免在公开场合暴露贵重物品及大量现金。
                                    </p>
                                    <p class="attention-li-content">
                                        ②上街时需时刻看管好贵重首饰，相机、手机等随身物品。
                                    </p>
                                    <p class="attention-li-content">
                                        ③游泳、漂流、潜水、溜冰、冲浪、探险、热气球、高山索道、滑雪等活动项目，均存在危险。参与前，请根据自身条件，充分参考当地相关部门及其他专业机构的相关公告和建议后，量力而行。<br>
                                    </p>
                                </div>
                                <!--<div class="attention-li">
                                    <div class="attention-li-title">
                                        · 关于饮食
                                    </div>
                                    <p class="attention-li-content">
                                        游泳、漂流、潜水、滑雪、溜冰、戏雪、冲浪、探险、热气球、高山索道等活动项目，均存在危险。参与前请根据自身条件，并充分参考当地相关部门及其它专业机构的相关公告和建议后量力而行。
                                    </p>
                                </div>
                                <div class="attention-li">
                                    <div class="attention-li-title">
                                        · 关于饮食
                                    </div>
                                    <p class="attention-li-content">
                                        如果你的口味是甜辣的，我们安排的是不辣不甜的，他家主打抬杠。
                                    </p>
                                </div>-->
                            </div>
                        </div>
                    </div>

                    <!--线路口碑-->
                    <div class="tr-scheduling xlkb">
                        <div class="scheduling-title">
                            <div class="scheduling-text">
                                <!--<img src="{{ asset('pc/image/index/pc_nav_icon_evaluation.png') }}" alt="">-->
                                <span>线路口碑</span>
                                <p class="evalueteAll">
                                  ({{ evalueteLength }})
                                </p>
                            </div>
                        </div>

                        <div class="tr-evaluate">
                            <div class="evaluate-list">
                                <div class="evaluate-box" v-for="(item,index) in evaluete" :key="index">
                                    <div class="evaluate-img">
                                        <img :src="item.headurl" alt="">
                                    </div>
                                    <div class="evaluate-detail">
                                        <div class="evaluate-user">
                                            <div class="evaluate-user-name">{{ item.name }}</div>
                                            <div class="evaluate-user-time">{{ item.datetime }}</div>
                                        </div>
                                        <div class="evaluate-score">
                                            <p>评价：</p>
                                            <div class="evaluate-score-box">
                                                <el-rate
                                                        v-model="item.score"
                                                        disabled
                                                        :colors="iconColor">
                                                </el-rate>
                                            </div>
                                        </div>
                                        <p class="evaluate-content">
                                            {{ item.content }}
                                        </p>
                                        <div class="evaluate-pic">
                                            <div class="evaluate-pic-single" v-for="(pic,index) in item.pic" :key="index">
                                                <img :src="pic" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <div class="hot-travel">
                    <div class="hot-travel-title">
                        本月热门线路
                    </div>
                    <div class="hot-travel-list">
                        <div class="hot-travel-single" v-for="(item,index) in hotList" :key="index"
                             @click="todetail(item.id)">
                            <div class="hot-travel-single-img">
                                <img :src="item.rotation" alt="">
                                <div class="hot-travel-label">
                                    {{ item.city_name }} · {{ item.travel_type }}
                                </div>
                            </div>

                            <div class="hot-travel-single-tit">
                                {{ item.title }}
                            </div>

                            <div class="hot-travel-single-money tra-flex-row tra-flex-justify-between tra-flex-align-end">
                                <div class="hot-travel-single-money-left">
                                    ¥ {{ item.adult_price }}
                                </div>
                                <div class="hot-travel-single-money-right">
                                    {{ item.number_applicants }} 人已报名
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="zanwuBoxHot" v-show="!hotList.length">
                        <div class="zanwuBoxAreaHot">
                            <img src="@/assets/images/persondata/null_img_xitong.png" alt="">
                            <span>暂无满足条件的线路，您可以重新筛选！！</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--底部-->
        <home-footer></home-footer>

    </div>
</template>

<script>
    import {mapMutations, mapGetters} from 'vuex';
    import {swiper, swiperSlide} from "vue-awesome-swiper";
    import homeNav from '@/components/homeNav';
    import homeFooter from '@/components/homeFooter';
    import calender from '@/components/calender';

    export default {
        name: "tourismDetail",
        components: {
            swiper,
            swiperSlide,
            homeNav,
            homeFooter,
            calender
        },
        data() {
            return {
                tourismId: '',
                title: '',
                redTit: '',
                peopleNumber: '',
                isCollect: false,
                collectIs: require('@/assets/images/tourism/shoucang.png'),
                collectNo: require('@/assets/images/tourism/no_shoucang.png'),
                adult_price: '',
                child_price: '',
                signal: [],
                rotation: [],
                city_name: '',
                travel_days: '',
                undertaker: '',
                travel_package: '',
                xc: [],
                price_contain: [],
                price_no_contain: [],
                refund_info: '',
                evaluete: [],
                evalueteLength: 0,
                iconColor: ['#FF5227', '#FF5227', '#FF5227'],
                hotList: [],

                active_notice: [],
                refund_ticket_info: '',
                ticket_changes_info: '',


                //轮播图配置
                swiperOptionTop: {
                    effect: "fade",
                    orderType: 0,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                },
                swiperOptionThumbs: {
                    spaceBetween: 20,
                    centeredSlides: true,
                    slidesPerView: 'left',
                    touchRatio: 0.5,
                    slideToClickedSlide: true,
                    // autoplay:true
                    autoplay: {
                        delay: 4000,
                        speed: 3000,
                        disableOnInteraction: true	//点击小图之后停止自动轮播
                    }
                },
                //轮播图数据
                imgData: [
                    /*{
                        img: require('@/assets/images/travel/icon01.png'),
                    },
                    {
                        img: require('@/assets/images/travel/icon02.png'),
                    },
                    {
                        img: require('@/assets/images/travel/icon03.png'),
                    }*/
                ],

                startTime: new Date(),
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                beginDate: '', //起始时间
                endDate: '', //终止时间
                timeData: [],
                crNumber: 0,
                etNumber: 0,
                tabList: [
                    {
                        text: '行程介绍'
                    },
                    {
                        text: '费用说明'
                    },
                    {
                        text: '活动须知'
                    },
                    {
                        text: '退订保障'
                    },
                    {
                        text: '用户评价'
                    },
                    {
                        text: '行程定制'
                    },
                ],
                currentNumber: 0
            }
        },
        computed: {
            ...mapGetters(['getCrNumber','getEtNumber']),
            crAllMoney: {
                get() {
                    return this.crNumber * this.adult_price;
                }
            },
            etAllMoney: {
                get() {
                    return this.etNumber * this.child_price;
                }
            },
            moneyAll(){
                return this.crNumber * this.adult_price + this.etNumber * this.child_price;
            }
        },
        created() {
            // this.getPassYearFormatDate();
            // console.log(this.$route.query.id);
            this.tourismId = this.$route.query.id;
        },
        mounted() {
            this.getDetailData(this.tourismId);
            this.crNumber = this.getCrNumber;
            this.etNumber = this.getEtNumber;
            this.saveCrNumber({'crNumber': this.crNumber});
            this.saveEtNumber({'etNumber': this.etNumber});

            this.getPassYearFormatDate();
        },
        methods: {
            ...mapMutations(['saveCrNumber','saveEtNumber','saveStartTime','saveEndTime']),
            /* 获取过去时间，并传值给现在时间 */
            getPassYearFormatDate() {
                var nowDate = new Date();
                var date = new Date(nowDate);
                date.setDate(date.getDate() - 0);
                var seperator1 = '-';
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = '0' + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = '0' + strDate;
                }
                var formatDate = year + seperator1 + month + seperator1 + strDate;
                this.getNowFormatDate(formatDate);
            },
            /* 获取现在时间，并接受过去时间的值 */
            getNowFormatDate(formatDate) {
                var date = new Date();
                var seperator1 = '-';
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = '0' + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = '0' + strDate;
                }
                var nowData = year + seperator1 + month + seperator1 + strDate;
                this.timeData = [formatDate, nowData]  // 默认赋值一年时间
            },
            collectBtn() {
                var id = this.tourismId;
                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                this.$axios.post('/travelCollect', {
                    t_id: id
                }).then((res) => {
                    loading.close();
                    res = res.data;
                    if (res.status == 200) {
                        this.isCollect = !this.isCollect;
                        if (this.isCollect) {
                            this.$message('收藏成功!');
                        } else {
                            this.$message('取消收藏成功!');
                        }
                    }
                }).catch((err) => {
                    loading.close();
                    console.log(err);
                });
            },
            getDetailData(id) {
                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$axios.post('/travelInfo', {
                    t_id: id
                }).then((res) => {
                    loading.close();
                    res = res.data;
                    if (res.status == 200) {
                        // console.log(res.data);
                        /*active_notice: [],
                            refund_ticket_info: '',
                            ticket_changes_info: '',
                         */
                        this.title = res.data.title;
                        this.redTit = res.data.small_title;
                        this.peopleNumber = res.data.number_applicants;
                        this.isCollect = res.data.is_collect;
                        this.imgData = res.data.rotation;
                        this.adult_price = res.data.adult_price ? res.data.adult_price : 0;
                        this.child_price = res.data.child_price ? res.data.child_price : 0;
                        this.signal = res.data.signal;
                        this.city_name = res.data.city_name;
                        this.travel_days = res.data.travel_days;
                        this.undertaker = res.data.undertaker;
                        this.travel_package = res.data.travel_package;
                        this.xc = res.data.xc;
                        this.price_contain = res.data.price_contain;
                        this.price_no_contain = res.data.price_no_contain;
                        this.refund_info = res.data.refund_info;
                        this.evalueteLength = res.data.evaluete.length;
                        var aaa = res.data.evaluete.forEach((item)=>{
                          item.score = Number(item.score);
                        });
                        this.evaluete = aaa;
                        this.active_notice = res.data.active_notice;
                        this.refund_ticket_info = res.data.refund_ticket_info;
                        this.ticket_changes_info = res.data.ticket_changes_info;

                    }
                }).catch((err) => {
                    loading.close();
                });
            },
            tabClick(idx) {
                this.currentNumber = idx;
            },
            crreduce() {
                if (this.crNumber <= 1) {
                    return;
                } else {
                    this.crNumber--;
                    this.saveCrNumber({'crNumber': this.crNumber});
                }
            },

            cradd() {
                this.crNumber++;
                this.saveCrNumber({'crNumber': this.crNumber});
            },

            etreduce() {
                if (this.etNumber <= 0) {
                    return;
                } else {
                    this.etNumber--;
                    this.saveEtNumber({'etNumber': this.etNumber});
                }
            },

            etadd() {
                this.etNumber++;
                this.saveEtNumber({'etNumber': this.etNumber});
            },

            signUp(){
                // console.log('马上报名');
                this.$router.push({name: 'ConfirmOrder', query: {id: this.tourismId}});
            },

            change(val) {
                console.log(val);
                this.saveStartTime();
                this.saveEndTime();
            }
        }
    }
</script>

<style scoped>
    @import './tourismDetail.css';
</style>



// WEBPACK FOOTER //
// src/pages/tourismDetail/tourismDetail.vue